<template>
  <div v-html="displayedHtml"></div>
</template>

<script>
import MarkdownIt from "markdown-it";

const md = new MarkdownIt({
  html: true,
  linkify: true,
  typographer: true,
});

export default {
  props: {
    text: { type: String, required: true }, // markdown текст, растёт
    speed: { type: Number, default: 20 }   // скорость печати
  },
  data() {
    return {
      prevText: "",     // уже отпечатанный текст
      buffer: "",       // очередь новых символов
      intervalId: null, // для анимации
      displayedHtml: "" // финальный HTML
    };
  },
  watch: {
    text(newVal, oldVal) {
      if (newVal.length > oldVal.length) {
        const diff = newVal.slice(oldVal.length); // только новые символы
        this.buffer += diff;
        this.startTyping();
      }
    }
  },
  methods: {
    startTyping() {
      if (this.intervalId) return; // уже печатает

      this.intervalId = setInterval(() => {
        if (this.buffer.length > 0) {
            const chunk = this.buffer.slice(0, 2); // берём сразу 3 символа
            this.prevText += chunk;
            this.buffer = this.buffer.slice(2);
            this.displayedHtml = md.render(this.prevText);
        } else {
            clearInterval(this.intervalId);
            this.intervalId = null;
        }
      }, this.speed);
    }
  },
  mounted() {
    // если пришёл готовый текст сразу
    if (this.text) {
      this.prevText = this.text;
      this.displayedHtml = md.render(this.prevText);
    }
  },
  beforeDestroy() {
    if (this.intervalId) clearInterval(this.intervalId);
  }
};
</script>



// WEBPACK FOOTER //
// src/components/typing-text.vue